import { core } from '@tock/coretypes';

import { oc } from 'ts-optchain';
import _ from 'lodash';

import AppConstants from 'constants/AppConstants';

interface LoyaltyProgramState {
  balance?: core.LoyaltyProgramBalance;
  numPointsToRedeem?: number;
  lastRequestedSubtotal?: number;
  requestInProgress: boolean;
  uniqueCheckNumber?: string;
}

const initialState: LoyaltyProgramState = {
  balance: undefined,
  lastRequestedSubtotal: undefined,
  numPointsToRedeem: undefined,
  requestInProgress: false,
  uniqueCheckNumber: undefined,
};

export default function reducer(
  state: LoyaltyProgramState = initialState,
  action: BaseTockAction
): LoyaltyProgramState {
  const { context, payload, type } = action;
  switch (type) {
    case AppConstants.LOYALTY_PROGRAM_LOGIN_STARTING: {
      return {
        ...state,
        requestInProgress: true,
      };
    }
    case AppConstants.LOYALTY_PROGRAM_LOGIN_DONE:
    case AppConstants.LOYALTY_PROGRAM_LOGIN_FAILED: {
      return {
        ...state,
        requestInProgress: false,
      };
    }
    case AppConstants.LOYALTY_PROGRAM_FETCH_BALANCE_STARTING: {
      return {
        ...state,
        lastRequestedSubtotal: context,
      };
    }
    case AppConstants.LOYALTY_PROGRAM_FETCH_BALANCE_DONE: {
      let numPointsToRedeem = 0;
      if (!_.isUndefined(state.numPointsToRedeem)) {
        if (payload.numPointsToRedeem < state.numPointsToRedeem) {
          numPointsToRedeem = payload.numPointsToRedeem;
        } else {
          numPointsToRedeem = state.numPointsToRedeem;
        }
      }
      const uniqueCheckNumber = payload.uniqueCheckNumber || undefined;
      return {
        ...state,
        balance: payload,
        numPointsToRedeem,
        uniqueCheckNumber,
      };
    }
    case AppConstants.LOYALTY_PROGRAM_POINTS: {
      return {
        ...state,
        numPointsToRedeem: payload,
      };
    }
    case AppConstants.PURCHASE_DONE:
    case AppConstants.LOCK_CLEAR:
    case AppConstants.LOCK_TICKETS_DONE:
    case AppConstants.AUTHENTICATION_CLEARED_DONE:
    case AppConstants.LOYALTY_PROGRAM_CLEAR: {
      return initialState;
    }

    case AppConstants.LOYALTY_PROGRAM_CLEAR_LOGIN_STARTING: {
      const uniqueCheckNumber = oc(state).balance.uniqueCheckNumber(undefined);
      return {
        ...initialState,
        uniqueCheckNumber,
      };
    }
    default:
      return state;
  }
}
